<template>
    <div>
        <div class="pt-lg-1">
            <div class="container-fluid">
                <div class="d-flex flex-row justify-content-between align-items-center my-1">
                    <div>
                        <h1 class="col-12 mb-1" v-html="headerTitle" />
                    </div>
                    <div v-if="showDigitalCartTooltip">
                        <div class="row justify-content-end">
                            <div class="col-auto">
                                <digital-cart-tooltip
                                    :title="digitalCartTooltipDto.title"
                                    :content="digitalCartTooltipDto.content"
                                    :cta-label="digitalCartTooltipDto.ctaLabel"
                                    :cta-url="digitalCartTooltipDto.cartPageUrl"
                                    :empty-cart="digitalCartTooltipDto.emptyCart"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <selected-offer
                    v-if="selectedOffer && hasOfferFromUrl"
                    class="my-1"
                    :title="selectedOffer.title"
                    :continue-without-mobile="selectedOffer.continueWithoutMobile"
                    :modify-mobile-label="selectedOffer.modifyMobileLabel"
                    :modify-offer="selectedOffer.modifyOffer"
                    :offer-label="selectedOffer.offerLabel"
                />

                <div class="d-webview-none">
                    <contract-phone-lines
                        v-if="contractInfos"
                        class="mb-md-1 my-lg-1"
                        :contract-infos="contractInfos"
                        :contract-list-infos="contractListObjects"
                    />
                </div>
                <incentive
                    v-if="incentiveDto && !selectedOffer"
                    :title="incentiveDto.question"
                    :text="incentiveDto.message"
                    :link-href="changerMobileLink"
                    :link-label="incentiveDto.linkLabel"
                />
                <intention-switch
                    v-if="intentionSwitchDto"
                    class="pb-1"
                    :shop-sosh="shop === 'SOSH'"
                    :title="intentionSwitchDto.title"
                    :inline-alert="intentionSwitchInlineAlert"
                    :acquisition-label="intentionSwitchDto.acquisitionLabel"
                    :tseul-label="intentionSwitchDto.tseulLabel"
                    :changer-de-mobile-label="intentionSwitchDto.changerDeMobileLabel"
                    :default-intention-checked="intentionParam"
                    :linked-with-results="true"
                    @switch-intention="switchIntention($event)"
                />
                <template v-if="customerPopin">
                    <customer-popin
                        id="customer-popin-id"
                        :title="customerPopin.customerPopinLabelsDto.title"
                        :subtitle="customerPopin.customerPopinLabelsDto.subtitle"
                        :text="customerPopin.customerPopinLabelsDto.text"
                        :button-label="customerPopin.customerPopinLabelsDto.buttonLabel"
                        :button-link="customerPopin.customerPopinLinksDto.buttonLink"
                        :link-label-html="customerPopin.customerPopinLabelsDto.linkLabelHtml"
                        :link="customerPopin.customerPopinLinksDto.link"
                        :intention="customerPopin.intention"
                    />
                </template>
            </div>
            <template v-if="loading && displaySkeletonPersoReco">
                <skeleton-reco-mobiles-card :with-subtitle="true" />
            </template>
            <template v-if="displayRecoMobiles">
                <reco-mobiles
                    :mobiles="reco.mobiles"
                    :title="reco.title"
                    :sub-title="reco.subTitle"
                    :shop="shop"
                    :advantage-messages="advantageMessages"
                    :data-pdb-zid="dataPdbZid"
                    :funding-details-dto="fundingDetailsDto"
                    @fundingDetailsClick="handleRecoMobilesFundingDetailsClick"
                />
            </template>

            <div class="container-fluid">
                <div id="mobile-filters" class="row pt-1 pt-md-2">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-5">
                                <p
                                    id="total-mobiles"
                                    class="font-size-16 lead fw-bold pb-0"
                                    role="alert"
                                    v-html="totalMobiles"
                                />
                            </div>

                            <div class="col-7 text-end">
                                <ob1-liens-icone
                                    is-button
                                    modal-id="slide-filters-modal"
                                    title="Trier et filtrer"
                                    class="noDefaultStyleButton"
                                    data-bs-toggle="modal"
                                    icon="icon-filter"
                                    type="button"
                                    data-oevent-category="selecteur_produit"
                                    data-oevent-action="trier_et_filtrer"
                                    data-oevent-label="ouverture_filtre"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="col-12 text-start">
                        <selector-chips-filter
                            :filters="filtersModelAndView"
                            :selected-status="selectedChipsStatusFilters"
                            :delete-chips-filters-label="deleteChipsFiltersLabel"
                            @change-chips-filter="deleteFilterHandler"
                            @delete-status-filter="deleteStatusHandler"
                            @delete-range-filter="deleteRangeHandler"
                            @delete-bonus-range-filter="deleteBonusRangeHandler"
                            @delete-all-chips-filter="onDeleteSelectionClick"
                        />
                    </div>

                    <div class="slide-popin-modal">
                        <slide-popin-modal-filter
                            :id="'slide-filters-modal'"
                            :aria-labelledby="'slide-filters'"
                            :delete-selection-label="deleteSelectionLabel"
                            :number-of-selected-filters="numberOfSelectedFilters"
                            :button-label="filtersButtonLabel"
                            @delete-selection-click="onDeleteSelectionClick"
                        >
                            <selector-filters
                                :filters="filtersModelAndView"
                                :sort-radio-buttons="sortRadioButtons"
                                :status-radio-buttons="statusModelAndView"
                                :state-label="stateLabel"
                                :search-filters-dto="searchFiltersDto"
                                @change-check-box="updateFiltersHandler"
                                @sort-item-click="sortHandler"
                                @status-item-click="updateStatusFilterHandler"
                            />
                        </slide-popin-modal-filter>
                    </div>
                </div>

                <ob1-message-alerte
                    v-if="mobiles.length === 0 && !loading"
                    :title="noResultLabel"
                    icon="icon-info"
                    type="info"
                />
                <div id="devicesDisplay" class="col-12 px-1">
                    <section v-if="showSelectorCard" class="row models-wrapper">
                        <article
                            v-if="mobiles.length!== 0 && selectorAnimationForPXF && isPxfEnabled"
                            class="col-12 p-0 mb-1 mb-md-0 selector-card h-100 d-flex flex-column"
                        >
                            <pxf-animation-card
                                :is-orange="shop === 'ORANGE'"
                                :title="selectorAnimationForPXF.title"
                                :sub-title="selectorAnimationForPXF.subTitle"
                                :text="selectorAnimationForPXF.text"
                                :url-access-wording="selectorAnimationForPXF.urlAccessWording"
                                :url="selectorAnimationForPXF.url"
                                :visual="selectorAnimationForPXF.visual"
                            />
                            <div class="payment-solutions-details" />
                        </article>
                        <article
                            v-for="(model, index) in mobiles.slice(0,4)"
                            :key="model.currentVersion.ean + '-' + index"
                            class="col-12 p-0 mb-1 mb-md-0 selector-card d-flex flex-column"
                        >
                            <selector-card
                                :model="model"
                                :advantage-messages="advantageMessages"
                                :is-price-inversion-enabled="isPriceInversionEnabled"
                                :loan-rate-zero-label="loanRateZeroLabel"
                                :loan-rate-zero-offer-label="loanRateZeroOfferLabel"
                                :device-already-in-cart-label="deviceAlreadyInCartLabel(model)"
                            />
                            <div class="d-flex payment-solutions-details">
                                <das-tooltip
                                    v-if="model.currentVersion.dasAccessible"
                                    :id="'tooltip-' + index"
                                    :das="model.currentVersion.dasAccessible"
                                    class="me-auto"
                                />
                                <FundingDetailsLink
                                    v-if="model.currentVersion.price.price.hasInstallmentPlan"
                                    :seo-id="model.currentVersion.seoId.value"
                                    :text="fundingDetailsDto.linkText"
                                    @fundingDetailsClick="handleFundingDetailsClick"
                                />
                            </div>
                        </article>
                        <article
                            v-if="showSelectorAnimation && mobiles.length!== 0 && selectorAnimationDto"
                            class="col-12 p-0 mb-1 mb-md-0 selector-card d-webview-none"
                        >
                            <div class="d-flex flex-column">
                                <selector-animation
                                    :title="selectorAnimationDto.title"
                                    :title-for-tag="selectorAnimationDto.titleForTag"
                                    :text="selectorAnimationDto.text"
                                    :url-access-wording="selectorAnimationDto.urlAccessWording"
                                    :url="selectorAnimationUrl"
                                    :visual="selectorAnimationDto.visual"
                                />
                                <div class="payment-solutions-details" />
                            </div>
                        </article>
                        <template v-if="mobiles.length >= 5">
                            <article
                                v-for="(model, index) in mobiles.slice(4, mobiles.length)"
                                :key="model.currentVersion.ean + '-' + (index + 4)"
                                class="col-12 p-0 mb-1 mb-md-0 selector-card d-flex flex-column"
                            >
                                <selector-card
                                    :model="model"
                                    :advantage-messages="advantageMessages"
                                    :is-price-inversion-enabled="isPriceInversionEnabled"
                                    :loan-rate-zero-label="loanRateZeroLabel"
                                    :loan-rate-zero-offer-label="loanRateZeroOfferLabel"
                                    :device-already-in-cart-label="deviceAlreadyInCartLabel(model)"
                                />
                                <div class="d-flex payment-solutions-details">
                                    <das-tooltip
                                        v-if="model.currentVersion.dasAccessible"
                                        :id="'tooltip-' + index + 4"
                                        :das="model.currentVersion.dasAccessible"
                                        class="me-auto"
                                    />
                                    <FundingDetailsLink
                                        v-if="model.currentVersion.price.price.hasInstallmentPlan"
                                        :seo-id="model.currentVersion.seoId.value"
                                        :text="fundingDetailsDto.linkText"
                                        @fundingDetailsClick="handleFundingDetailsClick"
                                    />
                                </div>
                            </article>
                        </template>
                    </section>
                    <!-- Popin de financement-->
                    <pxf-cb4x-modal
                        v-if="selectedFundingDetailVersionPrice"
                        modal-id="funding-details-popin"
                        :display-cb4x="selectedFundingDetailVersionPrice.cb4xAvailable"
                        :display-pxf="selectedFundingDetailVersionPrice.pxfAvailable"
                    >
                        <template v-if="selectedFundingDetailVersionPrice.cb4xAvailable" #cb4x-content>
                            <!-- 4xCB payant  -->
                            <paying-detail-cb4x-modal-content
                                v-if="fundingDetailsDto.cb4xPopin.withFees"
                                modal-id="funding-details-popin"
                                :oney-merchant-guid="fundingDetailsDto.cb4xPopin.oneyMerchantGuid"
                                :oney-widget-src="fundingDetailsDto.oneyWidgetSrc"
                                :counter-delay="fundingDetailsDto.counterDelay"
                                :amount="selectedFundingDetailVersionPrice.totalPriceWithPromo / 100"
                                :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                                :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                                :cgu="fundingDetailsDto.cb4xPopin.cgu"
                                :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                            />
                            <!-- 4xCB gratuit avec détail du prix  -->
                            <cb4x-modal-content
                                v-else-if="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees"
                                :header-block="fundingDetailsDto.cb4xPopin.headerBlock"
                                :payment-block="fundingDetailsDto.cb4xPopin.paymentBlock"
                                :payment-simulation-block="fundingDetailsDto.cb4xPopin.paymentSimulationBlock"
                                :how-to-benefit="fundingDetailsDto.cb4xPopin.howToBenefit"
                                :faq="fundingDetailsDto.cb4xPopin.faqBlock"
                                :cgu="fundingDetailsDto.cb4xPopin.cgu"
                                :monthly-price="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees.monthlyPrice"
                                :first-monthly-price="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees.firstMonthlyPrice"
                                :one-shot-price="selectedFundingDetailVersionPrice.spreadingPrice4xCbWithoutFees.oneShotPrice"
                                :illustration="fundingDetailsDto.cb4xPopin.imageZen"
                            />
                        </template>
                        <!-- Payez en 12x, 24x, 36x ou 48x  -->
                        <template v-if="selectedFundingDetailVersionPrice.pxfAvailable" #pxf-content>
                            <pxf-modal-content
                                :header-block-dto="fundingDetailsDto.pxfPopin.headerBlockDto"
                                :example-pxf-data="fundingDetailsDto.pxfPopin.examplePxfData"
                                :example-pxf-tab-subtitle="fundingDetailsDto.pxfPopin.examplePxfTabSubtitle"
                                :example-pxf-tab-title="fundingDetailsDto.pxfPopin.examplePxfTabTitle"
                                :version-pxf-data="selectedFundingDetailVersionPrice.versionPxfData"
                                :version-pxf-tab-title="fundingDetailsDto.pxfPopin.versionPxfTabTitle"
                                :pxf-legal-mentions-text="fundingDetailsDto.pxfPopin.pxfLegalMentionsText"
                                :illustration="fundingDetailsDto.pxfPopin.imageZen"
                                :financing-block="fundingDetailsDto.pxfPopin.financingBlock"
                                :cgu="fundingDetailsDto.pxfPopin.cguDto"
                                :how-to-benefit-dto="fundingDetailsDto.pxfPopin.howToBenefitDto"
                            />
                        </template>
                    </pxf-cb4x-modal>
                    <div v-if="loading" class="mt-1">
                        <skeleton-selector-card />
                    </div>
                    <div class="d-flex justify-content-center my-2">
                        <button
                            v-if="showMoreButton"
                            id="showMoreButton"
                            :disabled="loading"
                            class="btn btn-secondary mx-0"
                            @click="fetchMoreMobiles()"
                        >
                            Voir plus
                        </button>
                    </div>
                </div>
            </div>

            <!--/* Zone Description Segment pour le SEO */-->
            <div class="container-fluid">
                <div
                    v-if="details"
                >
                    <header-signature v-if="details.title" class="mb-1" :text="details.title" />
                    <div v-if="details.paragraph" class="lead text-mw mb-1" v-html="details.paragraph" />
                </div>
            </div>
        </div>

        <div class="content-visibility-auto">
            <div v-if="loading" class="container-fluid">
                <skeleton-mobiles-views-history-card />
            </div>
            <template v-else>
                <mobiles-views-history
                    v-if="mobilesViewsHistory"
                    :title="navigationHistoryTitle"
                    :track-zone="viewedMobilesTag"
                    :mobiles="mobilesViewsHistory.mobiles"
                    :intention="intentionParam"
                />
            </template>
        </div>
        <div v-if="isPxfEnabled && legalMentions.pxfMention" class="container-fluid mt-2 mb-2">
            <p class="fw-bold" v-html="legalMentions.pxfMention" />
        </div>
        <div class="bg-gray2 mt-1 pt-1 pb-1">
            <div class="container-fluid">
                <!--/* Zone Kit mains libres */-->
                <free-hands :text="freeHandsText" />
                <legal-mentions4x-cb
                    v-if="is4xCbEnabled && legalMentions.cb4xMention"
                    :label="legalMentions.cb4xMention"
                    :popin4x-cb="legalMentions.popin4xCb"
                />
            </div>
        </div>
    </div>
</template>
<script>
import ContractPhoneLines from "../ContractPhoneLines.vue";
import SelectorFilters from "./fragment/SelectorFilters.vue";
import SelectedOffer from "../SelectedOffer.vue";
import RecoMobiles from "./fragment/RecoMobiles.vue";
import SelectorChipsFilter from "./fragment/SelectorChipsFilter.vue";
import SlidePopinModalFilter from "./fragment/SlidePopinModalFilter.vue";
import Incentive from "../components/Incentive.vue";
import IntentionSwitch from "../components/IntentionSwitch.vue";
import CustomerPopin from "../components/CustomerPopin.vue";
import SelectorAnimation from "./fragment/SelectorAnimation.vue";
import SelectorCard from "./fragment/SelectorCard.vue";
import FreeHands from "../../../common/components/FreeHands.vue";
import SkeletonSelectorCard from "./fragment/SkeletonSelectorCard.vue";
import PxfAnimationCard from "./fragment/PxfAnimationCard.vue";
import HeaderSignature from "../../../common/components/vue/HeaderSignature.vue";
import SkeletonRecoMobilesCard from "./fragment/SkeletonRecoMobilesCard.vue";
import FundingDetailsLink from "../FundingDetailsLink.vue";
import MobilesViewsHistory from "../navigationhistory/MobilesViewsHistory.vue";
import {fetchMobilesViewsHistory} from "../navigationhistory/HistoryMobilesApi";
import SkeletonMobilesViewsHistoryCard from "../navigationhistory/SkeletonMobilesViewsHistoryCard.vue";
import PxfCb4xModal from "../components/PxfCb4xModal.vue";
import Cb4xModalContent from "../components/Cb4xModalContent.vue";
import PxfModalContent from "../components/PxfModalContent.vue";
import PayingDetailCb4xModalContent from "../components/PayingDetailCb4xModalContent.vue";
import DasTooltip from "../DasTooltip.vue";
import LegalMentions4xCb from "../components/LegalMentions4xCb.vue";
import DigitalCartTooltip from "../../../common/components/vue/tooltip/DigitalCartTooltip.vue";

const dto = JSON.parse(document.getElementById('selector').dataset.selector);
const title = JSON.parse(document.getElementById('selector').dataset.title);

const ACQUISITION_PARAM = "acquisition";
const CHANGER_DE_MOBILE_PARAM = "changer-de-mobile";
const PCM_PARAM = "pcm";
const RENOUVELLEMENT_PARAM = "renouvellement";
const TSEUL_PARAM = "terminal-seul";

export default {
    name: "Selector",
    components: {
        DigitalCartTooltip,
        LegalMentions4xCb,
        DasTooltip,
        PayingDetailCb4xModalContent, PxfModalContent, Cb4xModalContent, PxfCb4xModal,
        SkeletonMobilesViewsHistoryCard,
        MobilesViewsHistory,
        FundingDetailsLink,
        SkeletonRecoMobilesCard,
        HeaderSignature,
        PxfAnimationCard,
        SkeletonSelectorCard,
        ContractPhoneLines,
        FreeHands,
        SelectorFilters,
        SelectedOffer,
        RecoMobiles,
        SelectorChipsFilter,
        SlidePopinModalFilter,
        Incentive,
        IntentionSwitch,
        CustomerPopin,
        SelectorAnimation,
        SelectorCard
    },
    data() {
        return {
            //Données fixes
            selectorDto: dto,
            shop: dto.shop,
            universe: dto.universe,
            contractInfos: dto.contractInfos,
            contractListObjects: dto.contractListObjects,
            isContractInfosDisplayed: dto.isContractInfosDisplayed,
            legalMentions: dto.legalMentions,
            fundingDetailsDto: null,
            pvc: dto.pvc,
            paginationSize: dto.paginationSize,
            moreButtonLabel: dto.moreButtonLabel,
            deleteFiltersLabel: dto.deleteFiltersLabel,
            deleteChipsFiltersLabel: dto.deleteChipsFiltersLabel,
            noResultLabel: dto.noResultLabel,
            stateLabel: "Etat",
            searchFiltersDto: dto.searchFiltersDto,
            filtersButtonLabel: dto.filtersButtonLabel,
            advantageMessages: dto.advantageMessages,
            isPriceInversionEnabled: dto.priceInversionEnabled,
            loanRateZeroLabel: dto.loanRateZeroLabel,
            loanRateZeroOfferLabel: dto.loanRateZeroOfferLabel,
            incentiveDto: dto.incentiveDto,
            changerMobileLink: dto.changerMobileLink,
            intentionSwitchDto: dto.intentionSwitchDto,
            pcmoaInfoMessage: dto.pcmoaInfoMessage,
            customerPopin: dto.customerPopin,
            selectorAnimationDto: dto.selectorAnimationDto,
            selectorAnimationForPXF: dto.selectorAnimationForPXF,
            selectedOffer: dto.selectedOffer?.intention === dto.defaultIntention ? dto.selectedOffer : undefined,
            screenReaderMessages: dto.screenReaderMessages,
            navigationHistoryDto: dto.navigationHistoryDto,
            freeHandsText: dto.freeHandsText,
            dataPdbZid: dto.shop === 'ORANGE' ? 'shop-digital_selecteur-produit_client_zone-reco-tuile_' : 'shop-digital-sosh_selecteur-produit_client_zone-reco-tuile_',
            showNavigationHistory: dto.navigationHistoryDto.searchHistoryEnabled,
            viewedMobilesTag: dto.viewedMobilesTag,
            navigationHistoryTitle: dto.navigationHistoryDto.title,
            //Données variables
            is4xCbEnabled: false,
            isPxfEnabled: false,
            mobiles: [],
            recoForAcquisition: null,
            recoForPcm: null,
            recoForRenouvellement: null,
            recoForTSeul: null,
            totalMobiles: "",
            filtersForIntentions: [],//On stocke ici les filtres retournés par l'API pour toutes les intentions
            filters: null,//les filtres de l'API pour l'intention en cours
            loading: true,
            showMoreButton: false,
            showSelectorCard: false, // paramètre pour dire si on affiche ou pas la liste des mobiles
            showSelectorAnimation: true,
            intentionParam: dto.defaultIntention,
            selectedSort: "",
            selectedStatus: "",
            selectedBrands: [],
            selectedRanges: [],
            selectedRefurbishedBrands: [],
            selectedSegments: [],
            selectedCompatibilities: [],
            selectedPrices: [],
            selectedRepairabilities: [],
            selectedBonusRecovery: "",
            selectedBonusRecoveryRanges: [],
            disu: false,
            availableOnline: false,
            page: 1,
            displaySkeletonPersoReco: dto.displaySkeletonPersoReco,
            widgetAmount: undefined,
            versionPxfData: [],
            selectedFundingDetailVersionPrice: undefined,
            mobilesViewsHistory: null,
            headerTitle: title,
            selectorAnimationUrl: '',
            digitalCartTooltipDto: dto.digitalCartTooltipDto,
            withDigitalCartInternet: dto.withDigitalCartInternet,
            deviceFromCart: dto.deviceFromCart,
            hasOfferFromUrl: dto.hasOfferFromUrl
        }
    },
    computed: {
        devicePriceKey: function(){
            return this.selectedOffer?.devicePriceKey
        },
        offerSeoId: function() {
            return this.selectedOffer?.offerSeoId
        },
        deleteSelectionLabel: function () {
            return this.deleteFiltersLabel + ' (' + this.numberOfSelectedFilters + ')'
        },
        hasNoFilters() {
            return this.numberOfSelectedFilters === 0;
        },
        displayRecoMobiles() {
            return this.mobiles.length > 0 && !this.loading && this.hasNoFilters && this.reco && this.reco.mobiles.length > 0;
        },
        reco() {
            switch(this.intentionParam) {
                case ACQUISITION_PARAM:
                    return this.recoForAcquisition;
                case PCM_PARAM:
                    return this.recoForPcm;
                case RENOUVELLEMENT_PARAM:
                    return this.recoForRenouvellement;
                case TSEUL_PARAM:
                    return this.recoForTSeul;
            }
            return null;
        },
        intentionSwitchInlineAlert() {
            if (this.intentionParam === PCM_PARAM || this.intentionParam === RENOUVELLEMENT_PARAM) {
                return this.pcmoaInfoMessage;
            } else {
                return null;
            }
        },
        statusModelAndView() {
            return [
                {
                    radioButtonDTO: {
                        id: "tous",
                        name: "etat",
                        label: "",
                        checked: this.selectedStatus === "",
                        ariaLabelledBy: "tous-label",
                        value: ""
                    },
                    primaryText: "Tous"
                },
                {
                    radioButtonDTO: {
                        id: "neuf",
                        name: "etat",
                        label: "",
                        checked: this.selectedStatus === "neuf",
                        ariaLabelledBy: "neuf-label",
                        value: "neuf"
                    },
                    primaryText: "Neuf"
                },
                {
                    radioButtonDTO: {
                        id: "reconditionne",
                        name: "etat",
                        label: "",
                        checked: this.selectedStatus === "reconditionne",
                        ariaLabelledBy: "reconditionne-label",
                        value: "reconditionne"
                    },
                    primaryText: "Reconditionné"
                }
            ]
        },
        filtersModelAndView() {
            if (this.filters) {
                let checkboxes = [
                    {
                        checkboxes: this.filters.segmentsFilter.segments.map(segment => {
                            return {
                                label: segment.label,
                                details: segment.details,
                                isChecked: this.selectedSegments.includes(segment.id),
                                mobilesCount: null,
                                id: segment.id,
                                filterId: 'segments-' + segment.id,
                                ranges: []
                            }
                        }),
                        label: this.filters.segmentsFilter.title,
                        id: "segments-filter",
                        screenReaderSortOrder: 6
                    },
                    {
                        checkboxes: this.filters.refurbishedSegmentsFilter.segments.map(segment => {
                            return {
                                label: segment.label,
                                details: segment.details,
                                isChecked: this.selectedSegments.includes(segment.id),
                                mobilesCount: null,
                                id: segment.id,
                                filterId: 'refurbished-segments-' + segment.id,
                                ranges: []
                            }
                        }),
                        label: this.filters.refurbishedSegmentsFilter.title,
                        id: "refurbished-segments-filter",
                        screenReaderSortOrder: 6
                    },
                    {
                        checkboxes: this.filters.otherSegmentsFilter.segments.map(segment => {
                            return {
                                label: segment.label,
                                details: segment.details,
                                isChecked: this.selectedSegments.includes(segment.id),
                                mobilesCount: null,
                                id: segment.id,
                                filterId: 'other-segments-' + segment.id,
                                ranges: []
                            }
                        }),
                        label: this.filters.otherSegmentsFilter.title,
                        id: "other-segments-filter",
                        screenReaderSortOrder: 6
                    },
                    {
                        checkboxes: this.filters.pricesFilter.prices.map(price => {
                            return {
                                label: price.label,
                                isChecked: this.selectedPrices.includes(price.id),
                                mobilesCount: price.count,
                                id: price.id,
                                filterId: 'price-filter-' + price.id,
                                ranges: []
                            }
                        }),
                        label: this.filters.pricesFilter.title,
                        id: "price-filter",
                        screenReaderSortOrder: 3
                    },
                    {
                        checkboxes: this.filters.brandsNewFilter.brands.map(brand => {
                            let ranges = brand.ranges.map(range => {
                                return {
                                    label: range.label,
                                    id: range.id,
                                    details: range.details,
                                    isChecked: this.selectedRanges.includes(range.id),
                                }
                            })
                            return {
                                label: brand.label,
                                isChecked: this.selectedBrands.includes(brand.id) || ranges.filter(range => range.isChecked).length > 0,
                                mobilesCount: brand.count,
                                id: brand.id,
                                filterId: 'brand-filter-' + brand.id,
                                ranges: ranges
                            }
                        }),
                        label: this.filters.brandsNewFilter.title,
                        id: "brand-filter",
                        screenReaderSortOrder: 1
                    },
                    {
                        checkboxes: this.filters.brandsRefurbishedFilter.brands.map(brand => {
                            let ranges = brand.ranges.map(range => {
                                return {
                                    label: range.label,
                                    id: range.id,
                                    details: range.details,
                                    isChecked: this.selectedRanges.includes(range.id),
                                }
                            })
                            return {
                                label: brand.label,
                                isChecked: this.selectedRefurbishedBrands.includes(brand.id) || ranges.filter(range => range.isChecked).length > 0,
                                mobilesCount: brand.count,
                                id: brand.id,
                                filterId: 'brand-refurbished-filter-' + brand.id,
                                ranges: ranges
                            }
                        }),
                        label: this.filters.brandsRefurbishedFilter.title,
                        id: "brand-refurbished-filter",
                        screenReaderSortOrder: 2
                    },
                    {
                        checkboxes: this.filters.compatibilitiesFilter.compatibilities.map(compatiblity => {
                            return {
                                label: compatiblity.label,
                                isChecked: this.selectedCompatibilities.includes(compatiblity.id),
                                mobilesCount: compatiblity.count,
                                id: compatiblity.id,
                                filterId: 'compatibility-filter-' + compatiblity.id,
                                ranges: []
                            }
                        }),
                        label: this.filters.compatibilitiesFilter.title,
                        id: "compatibility-filter",
                        screenReaderSortOrder: 5
                    }
                ]
                if (this.filters.repairabilitiesFilter) checkboxes.push(
                    {
                        checkboxes: this.filters.repairabilitiesFilter.repairabilities.map(repairability => {
                            return {
                                label: repairability.label,
                                isChecked: this.selectedRepairabilities.includes(repairability.id),
                                mobilesCount: repairability.count,
                                id: repairability.id,
                                filterId: 'repairability-filter-' + repairability.id,
                                ranges: []
                            }
                        }),
                        label: this.filters.repairabilitiesFilter.title,
                        note: this.filters.repairabilitiesFilter.subTitle,
                        tooltip: this.filters.repairabilitiesFilter.info,
                        id: "repairability-filter",
                        screenReaderSortOrder: 7
                    }
                )
                if (this.filters.bonusRecoveryFilter) {
                    let ranges = this.filters.bonusRecoveryFilter.bonusRanges.map(item => {
                        return {
                            label: item.label,
                            isChecked: this.selectedBonusRecoveryRanges.includes(item.id),
                            mobilesCount: item.count,
                            id: item.id,
                            filterId: 'bonus-recovery-ranges-filter-' + item.id,
                            ranges: []
                        }
                    });
                    let id = this.filters.bonusRecoveryFilter.id;
                    checkboxes.push(
                        {
                            checkboxes: [{
                                label: this.filters.bonusRecoveryFilter.label,
                                chipsLabel: this.filters.bonusRecoveryFilter.chipsLabel,
                                isChecked: this.selectedBonusRecovery === "true",
                                mobilesCount: this.filters.bonusRecoveryFilter.count,
                                id: id,
                                filterId: 'bonus-recovery-filter-' + id,
                                ranges: ranges
                            }
                            ],
                            label: this.filters.bonusRecoveryFilter.title,
                            id: "bonus-recovery-filter",
                            screenReaderSortOrder: 4
                        }
                    )
                }
                return checkboxes
            } else return []
        },
        filtersBrand() {
            return this.filtersModelAndView.find(filter => filter.id === "brand-filter")
        },
        filtersRefurbishedBrand() {
            return this.filtersModelAndView.find(filter => filter.id === "brand-refurbished-filter")
        },
        numberOfSelectedFilters() {
            return this.selectedFiltersData.numberOfSelectedFilters;
        },
        sortRadioButtons() {
            return [
                {
                    radioButtonDTO: {
                        id: "pertinence",
                        name: "tri",
                        label: "",
                        checked: this.selectedSort === "",
                        ariaLabelledBy: "pertinence",
                        value: ""
                    },
                    primaryText: "pertinence"
                },
                {
                    radioButtonDTO: {
                        id: "par-prix-asc",
                        name: "tri",
                        label: "",
                        checked: this.selectedSort === "par-prix-asc",
                        ariaLabelledBy: "prix-croissant",
                        value: "par-prix-asc"
                    },
                    primaryText: "prix croissant"
                },
                {
                    radioButtonDTO: {
                        id: "par-prix-desc",
                        name: "tri",
                        label: "",
                        checked: this.selectedSort === "par-prix-desc",
                        ariaLabelledBy: "prix-decroissant",
                        value: "par-prix-desc"
                    },
                    primaryText: "prix décroissant"
                },
                {
                    radioButtonDTO: {
                        id: "par-note",
                        name: "tri",
                        label: "",
                        checked: this.selectedSort === "par-note",
                        ariaLabelledBy: "meilleurs-notes",
                        value: "par-note"
                    },
                    primaryText: "meilleures notes"
                }
            ]
        },
        totalMobilesFiltersLabel() {
            return this.selectedFiltersData.complementaryLabel
        },
        totalMobilesSortLabel() {
            let sortLabel;
            let sortRadioButton = this.sortRadioButtons.find(
                sort => sort.radioButtonDTO.value === this.selectedSort)
            if (sortRadioButton) {
                sortLabel = sortRadioButton.primaryText;
            } else {
                sortLabel = this.sortRadioButtons[0].primaryText;
            }
            return this.screenReaderMessages.sortLabel + " " + sortLabel;
        },
        selectedChipsStatusFilters: function () {
            let selectedChipsFilters;
            //chips pour le filtre etat (neuf, reconditionné)
            this.statusModelAndView.forEach((status) => {
                if (status.radioButtonDTO.id !== "tous" && status.radioButtonDTO.checked === true) {
                    selectedChipsFilters = status;
                }
            });

            return selectedChipsFilters;
        },
        selectedFiltersData() {
            let complementaryLabel = "";
            let filterCounter = 0;                  // tous les filtres hors gammes, statut inclus
            let filterRangeCounter = 0;             // toutes les gammes
            if (this.selectedChipsStatusFilters) {
                // Ajoute le label du filtre "Etat"
                complementaryLabel += this.stateLabel + " " + this.selectedChipsStatusFilters.primaryText + ", ";
                filterCounter++;
            }
            // Trie les filtres dans le même ordre que les chips affichées
            // (la liste des filtres est préalablement dupliquée, pour qu'elle ne soit pas mutée par le tri)
            let sortedFilters = [...this.filtersModelAndView].sort(
                (firstItem, secondItem) => firstItem.screenReaderSortOrder - secondItem.screenReaderSortOrder);
            for (let filter of sortedFilters) {
                let filterLabel = ""
                filter.checkboxes.forEach((checkbox) => {
                    if (checkbox.isChecked) {
                        // Ajoute le label du filtre
                        filterLabel += " " + checkbox.label;
                        let rangeCounter = 0;
                        checkbox.ranges.forEach(range => {
                            if (range.isChecked) {
                                filterLabel += " " + range.label
                                rangeCounter++;
                            }
                        });
                        if (rangeCounter > 0) {
                            // Le nombre de gammes sélectionnées est ajouté au compteur, mais pas la brand
                            // ex : Apple + iPhone 17 + iPhone 16 compte pour deux filtres.
                            filterRangeCounter += rangeCounter;
                        } else {
                            // Aucune gamme n'est sélectionnée, la brand est ajoutée au compteur
                            // ex: Apple sans gamme sélectionnée compte pour un filtre.
                            filterCounter++;
                        }
                    }
                });
                if (filterLabel.length > 0) {
                    complementaryLabel += filter.label + filterLabel + ", ";
                }
            }
            const totalFilters = filterCounter + filterRangeCounter // tous les filtres, gammes et statut compris
            if (totalFilters === 1) {
                complementaryLabel = this.screenReaderMessages.oneFilterLabel + " " + complementaryLabel;
            } else if (totalFilters > 1) {
                complementaryLabel = this.screenReaderMessages.multipleFiltersLabel + " " + complementaryLabel;
            }

            return {
                numberOfSelectedFilters: totalFilters,
                complementaryLabel: complementaryLabel
            };
        },
        details() {
            if (this.numberOfSelectedFilters > 1) {
                return null;
            }
            if (this.selectedSegments.length === 1) {
                let segmentFilters = this.filtersModelAndView.find(filter => filter.id === "segments-filter")?.checkboxes.find((checkbox) => checkbox.isChecked);
                if (segmentFilters != null) return segmentFilters.details;
                segmentFilters = this.filtersModelAndView.find(filter => filter.id === "refurbished-segments-filter")?.checkboxes.find((checkbox) => checkbox.isChecked);
                if (segmentFilters != null) return segmentFilters.details;
                segmentFilters = this.filtersModelAndView.find(filter => filter.id === "other-segments-filter")?.checkboxes.find((checkbox) => checkbox.isChecked);
                if (segmentFilters != null) return segmentFilters.details;
            }
            if (this.selectedRanges.length === 1) {
                let brandFilter = this.filtersModelAndView.find(filter => filter.id === "brand-filter")?.checkboxes.find((checkbox) => checkbox.isChecked);
                if (brandFilter != null) {
                    let rangeFilter = brandFilter.ranges.find((range) => range.isChecked);
                    if (rangeFilter != null) return rangeFilter.details;
                } else {
                    let brandFilterRefurbished = this.filtersModelAndView.find(filter => filter.id === "brand-refurbished-filter")?.checkboxes.find((checkbox) => checkbox.isChecked);
                    if (brandFilterRefurbished != null) {
                        let rangeFilter = brandFilterRefurbished.ranges.find((range) => range.isChecked);
                        if (rangeFilter != null) return rangeFilter.details;
                    }
                }
            }
            return null;
        },
        showDigitalCartTooltip() {
            return  this.digitalCartTooltipDto
        }
    },
    mounted: function () {
        jQuery(document).ready(()  => {

            this.init();

            // Mise à jour des hauteurs des tuiles
            window.addEventListener("resize", () => {
                this.updateLayout();
            });

            // Evenement pour capter le back navigateur
            window.addEventListener('popstate', function () {
                window.location = window.location.href;
            }, false);

            // Gestion de la popin utilisateur
            const customerPopin = $('#customer-popin-id');
            customerPopin.on('hide.bs.modal', () => {
                this.intentionParam = ACQUISITION_PARAM;
                this.updatePageUrlWithIntention();
            });
            if (dto.displayCustomerPopin) {
                customerPopin.modal('show');
            }
        })

    },
    updated() {
        this.$nextTick(function () {
            this.updateLayout();
            if (this.selectorAnimationDto) {
                this.updateSelectorAnimationUrl(this.selectorAnimationDto.url);
            }
        })
    },
    methods: {
        // Pour la tuile animation Navad, en attendant une évolution sur une tuile spécifique par intention dans Edithor.
        // On ajoute le paramètre intention dans l'URL de la tuile Navad.
        // On utilise l'intention présente dans l'URL et non de celle dans `intentionParam`, car elles peuvent être différentes
        // (exemple : [url]?intention=changer-de-mobile peut avoir la valeur intentionParam=renouvellement).
        updateSelectorAnimationUrl: function (url) {
            const urlParams = new URLSearchParams(window.location.search);
            const intention = urlParams.get('intention');
            this.selectorAnimationUrl = intention ? addParam(url, 'intention=' + intention) : url;
        },
        init: function () {
            this.selectedSort = this.getParam('sort');
            this.selectedStatus = this.getParam('status');
            this.disu = this.getParam('disu');
            this.availableOnline = this.getParam('availableOnline');
            if (this.getParam('bonus-ranges')) this.selectedBonusRecoveryRanges = this.getParam('bonus-ranges').split(',');
            if (this.selectedBonusRecoveryRanges.length > 0) {
                this.selectedBonusRecovery = "true";
            } else {
                this.selectedBonusRecovery = this.getParam('bonus');
            }
            this.page = this.getPageNumber();
            if (this.getParam('segment')) this.selectedSegments = this.getParam('segment').split(',');
            if (this.getParam('brand')) this.selectedBrands = this.getParam('brand').split(',');
            if (this.getParam('refurbished-brand')) this.selectedRefurbishedBrands = this.getParam('refurbished-brand').split(',');
            if (this.getParam('compatibility')) this.selectedCompatibilities = this.getParam('compatibility').split(',');
            if (this.getParam('price')) this.selectedPrices = this.getParam('price').split(',');
            if (this.getParam('repairability')) this.selectedRepairabilities = this.getParam('repairability').split(',');
            if (this.getParam('range')) this.selectedRanges = this.getParam('range').split(',');

            this.loadFilters(this.intentionParam).then(
                filters => {
                    this.filters = filters
                    this.loadMobiles(0, this.getPageNumber() * this.paginationSize).then(
                            this.loadOrRegisterMobilesViewsHistory()
                    )
                }
            );

            this.updateFinancingPopin();
        },
        getPageNumber: function () {
            let page = parseInt(getParameterByName('page', window.location.href))
            if (Number.isNaN(page) || page <= 0) {
                page = 1
            }
            return page;
        },
        getParam: function (paramName) {
            let param = getParameterByName(paramName, window.location.href)
            if (param === null || param === undefined) {
                param = ""
            }
            return param;
        },
        fetchFilters: function () {
            let url = "/api/mobile/filters"
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "shop": this.shop,
                        "universe": this.universe,
                        "intention": this.intentionParam,
                        "devicePriceKey": this.devicePriceKey
                    },
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            })
        },
        fetchMobiles(startIndex, lastIndex) {
            let url = "/api/mobile/mobiles"

            const priceFilters = this.selectedPrices.toString();
            const repairabilityFilters = this.selectedRepairabilities.toString();
            const brandFilters = this.selectedBrands.toString();
            const refurbishedBrandFilters = this.selectedRefurbishedBrands.toString();
            const compatibilityFilters = this.selectedCompatibilities.toString();
            const segments = this.selectedSegments.toString();
            const rangeFilters = this.selectedRanges.toString();
            const bonusRangesFilters = this.selectedBonusRecoveryRanges.toString();

            let hasAppleBrandFilteredRanges;
            if (this.filters) {
                const appleBrand = this.filters.brandsNewFilter.brands.find(brand => brand.id === "apple");
                hasAppleBrandFilteredRanges = appleBrand?.ranges.some(range => rangeFilters.includes(range.id)) ?? false;
            } else {
                hasAppleBrandFilteredRanges = false;
            }

            // On demande la reco si on ne la pas déjà chargée et si on n'a pas de filtre
            let reco = false;
            if (this.hasNoFilters) {
                switch (this.intentionParam) {
                    case ACQUISITION_PARAM:
                        reco = this.recoForAcquisition == null;
                        break;
                    case PCM_PARAM:
                        reco = this.recoForPcm == null;
                        break;
                    case RENOUVELLEMENT_PARAM:
                        reco = this.recoForRenouvellement == null;
                        break;
                    case TSEUL_PARAM:
                        reco = this.recoForTSeul == null;
                        break;
                }
            }

            this.showSelectorAnimation = this.displayAnimation(brandFilters, segments, refurbishedBrandFilters, hasAppleBrandFilteredRanges);
            return new Promise((resolve, reject) => {
                $.ajax({
                    method: "GET",
                    data: {
                        "from": startIndex,
                        "to": lastIndex,
                        "sort": this.selectedSort,
                        "shop": this.shop,
                        "universe": this.universe,
                        "intention": this.intentionParam,
                        "offer": this.offerSeoId,
                        "brands": brandFilters,
                        "refurbished-brands": refurbishedBrandFilters,
                        "ranges": rangeFilters,
                        "prices": priceFilters,
                        "repairabilities": repairabilityFilters,
                        "compatibilities": compatibilityFilters,
                        "segments": segments,
                        "status": this.selectedStatus,
                        "disu": this.disu,
                        "availableOnline": this.availableOnline,
                        "reco": reco,
                        "bonus": this.selectedBonusRecovery,
                        "bonus-ranges": bonusRangesFilters,
                        "withDigitalCartInternet": this.withDigitalCartInternet,
                        "deviceFromCart": this.deviceFromCart?.value,
                        "hasOfferFromUrl": this.hasOfferFromUrl,
                    },
                    url: url,
                    contentType: "application/json",
                    dataType: "json"
                }).done(result => {
                    resolve(result)
                }).fail(error => {
                    reject(error)
                })
            })
        },
        loadFilters: function (intentionParam) {
            return new Promise((resolve) => {
                this.loading = true
                let filtersForIntention = this.filtersForIntentions[intentionParam]
                if (filtersForIntention == null) {
                    this.fetchFilters().then(filters => {
                        this.filtersForIntentions[intentionParam] = filters;
                        resolve(filters)
                    }).catch((error) => {
                        if (error.status !== 0) {
                            if (error.status === 403) {
                                window.location.href = dto.sessionLostUrl;
                            } else if (window.MyShop?.crashLogReporter) {
                                    let reporter = window.MyShop.crashLogReporter;
                                    reporter.logError(error);
                            }
                        }
                        this.loading = false;
                        resolve(null)
                    });
                } else {
                    resolve(filtersForIntention)
                }
            })
        },
        loadMobiles(startIndex, lastIndex) {
            return new Promise((resolve) => {
                this.loading = true;
                this.showSelectorCard = startIndex !== 0; // On doit continuer d'afficher les tuiles courantes au Voir plus
                this.fetchMobiles(startIndex, lastIndex).then(result => {
                    if (startIndex === 0) {
                        this.mobiles = result.mobiles;
                    } else {
                        this.mobiles.push.apply(this.mobiles, result.mobiles);
                    }
                    this.headerTitle = result.headerTitle;
                    if (result.reco) {
                        switch (this.intentionParam) {
                            case ACQUISITION_PARAM:
                                this.recoForAcquisition = result.reco;
                                break;
                            case PCM_PARAM:
                                this.recoForPcm = result.reco;
                                break;
                            case RENOUVELLEMENT_PARAM:
                                this.recoForRenouvellement = result.reco;
                                break;
                            case TSEUL_PARAM:
                                this.recoForTSeul = result.reco;
                                break;
                        }
                    }

                    let complementaryLabel = this.totalMobilesFiltersLabel + this.totalMobilesSortLabel;
                    this.totalMobiles = result.totalMobiles + "<span class=\"visually-hidden\">, " + complementaryLabel + "</span>";
                    this.showSelectorCard = true;
                    this.showMoreButton = result.hasMore;
                    this.is4xCbEnabled = result.cb4xEnabled;
                    this.isPxfEnabled = result.pxfEnabled;
                    this.loading = false;
                    resolve(result);
                }).catch((error) => {
                    if (error.status !== 0) {
                        if (error.status === 404) {
                            // Aucun mobile n'a été trouvé, on affiche un message d'erreur.
                            this.mobiles = [];
                            this.totalMobiles = "";
                            this.showSelectorCard = false;
                            this.showMoreButton = false;
                            this.loading = false;
                        } else if (error.status === 403) {
                            window.location.href = dto.sessionLostUrl;
                        } else if (window.MyShop?.crashLogReporter) {
                                let reporter = window.MyShop.crashLogReporter;
                                reporter.logError(error).then(() => {
                                    window.location.href = dto.infoViewUrl;
                                });
                            } else {
                                window.location.href = dto.infoViewUrl;
                            }
                    }
                    this.loading = false;
                    resolve(null)
                });
            });
        },
        loadOrRegisterMobilesViewsHistory() {
            if (window['o_idzone_is_loaded']) {
                //l'événement a déjà été émis, on peut exécuter directement du code dépendant de o_idzone
                this.loadMobilesViewsHistory()
            } else {
                //idZone n'est pas encore disponible, on s'abonne à l'événement
                addEventListener('idzone:loaded', () => {
                    //idZone est disponible, on peut utiliser les variables
                    this.loadMobilesViewsHistory()
                }, {once: true})
            }
        },
        loadMobilesViewsHistory() {
            return new Promise((resolve) => {
                // Historique de navigation : on appelle l'api que si le browserId est présent, clé activée et aussi l'univers différent de DATA
                // Le browserId est récupéré depuis le cookie o_idzone CLIENT_ID c'est une valeur unique par navigateur
                // Pour un client connecté le clientId est récupéré depuis le cookie o_idzone USER_EXTERNAL_ID_HASH c'est une valeur unique par client
                let browserId = window.o_idzone ? window.o_idzone.CLIENT_ID : null;
                let clientId = window.o_idzone ? window.o_idzone.USER_EXTERNAL_ID_HASH: null;
                let offer = this.selectedOffer ? this.selectedOffer.offerSeoId : null
                if (browserId && this.showNavigationHistory) {
                    fetchMobilesViewsHistory(this.shop, offer, this.universe, browserId, clientId, this.intentionParam).then(result => {
                        this.mobilesViewsHistory = result;
                        resolve(result)
                    }).catch((error) => {
                        if (window.MyShop?.crashLogReporter) {
                            let reporter = window.MyShop.crashLogReporter;
                            reporter.logError(error);
                        }
                        resolve(null)
                    });
                }
            });
        },
        fetchMoreMobiles: function () {
            let startIndex = this.mobiles.length
            let currentPage = Math.floor((startIndex - 1) / this.paginationSize) + 1
            this.page = currentPage + 1
            this.updateUrl()
            this.loadMobiles(startIndex, this.page * this.paginationSize)
        },
        sortHandler: function (sort) {
            this.selectedSort = sort
            this.page = 1
            this.updateUrl()
            this.loadMobiles(0, this.page * this.paginationSize);
        },
        updateFiltersHandler: function (filters) {
            if (filters['brand-filter']) {
                // On ne stocke que les marques qui n'ont pas de gammes sélectionnées
                this.selectedBrands = filters['brand-filter'].filter(brand => brand.ranges.length === 0).map(brand => brand.id)
                this.selectedRanges = filters['brand-filter'].flatMap(brand => brand.ranges)
            }

            if (filters['brand-refurbished-filter']) {
                // On ne stocke que les marques qui n'ont pas de gammes sélectionnées
                this.selectedRefurbishedBrands = filters['brand-refurbished-filter'].filter(brand => brand.ranges.length === 0).map(brand => brand.id)
                let refurbishedRanges = filters['brand-refurbished-filter'].flatMap(brand => brand.ranges)
                if (refurbishedRanges.length > 0) {
                    this.selectedRanges = this.selectedRanges.concat(refurbishedRanges)
                }
            }
            if (filters['segments-filter'] || filters['refurbished-segments-filter']) this.selectedSegments = filters['segments-filter'].map(segment => segment.id).concat(filters['refurbished-segments-filter'].map(segment => segment.id))
            if (filters['compatibility-filter']) this.selectedCompatibilities = filters['compatibility-filter'].map(compatibility => compatibility.id)
            if (filters['price-filter']) this.selectedPrices = filters['price-filter'].map(price => price.id)
            if (filters['repairability-filter']) this.selectedRepairabilities = filters['repairability-filter'].map(repairability => repairability.id)
            if (filters['bonus-recovery-filter']) {
                this.selectedBonusRecovery = filters['bonus-recovery-filter'].find(item => item.id === 'tous') != null ? "true" : "";
                this.selectedBonusRecoveryRanges = filters['bonus-recovery-filter'].flatMap(item => item.ranges);
            }
            this.updateUrl()

            this.filterMobiles()
        },
        updateStatusFilterHandler: function (status) {
            this.selectedStatus = status
            if (status === "neuf") {
                this.selectedRefurbishedBrands = []
                // On supprime toutes les gammes reconditionnées
                let refurbishedRanges = this.filtersRefurbishedBrand.checkboxes.flatMap(brand => brand.ranges.map(range => range.id))
                this.selectedRanges = this.selectedRanges.filter(item => !refurbishedRanges.includes(item))
            } else if (status === "reconditionne") {
                this.selectedBrands = []
                // On supprime toutes les gammes neuves
                let newRanges = this.filtersBrand.checkboxes.flatMap(brand => brand.ranges.map(range => range.id))
                this.selectedRanges = this.selectedRanges.filter(item => !newRanges.includes(item))
            }
            this.updateUrl()

            this.filterMobiles()
        },
        //Mise à jour des filtres si suppression d'une chips de filtre
        deleteFilterHandler: function (filterName, filterId) {
            if (filterName === 'brand-filter') {
                this.selectedBrands = this.selectedBrands.filter((item) => item !== filterId)
                // On supprime toutes les gammes associées à cette marque
                let brand = this.filtersBrand.checkboxes.find(item => item.id === filterId)
                if (brand?.ranges) {
                    let ranges = brand.ranges.map(item => item.id)
                    this.selectedRanges = this.selectedRanges.filter(item => !ranges.includes(item))
                }
            }
            if (filterName === 'brand-refurbished-filter') {
                this.selectedRefurbishedBrands = this.selectedRefurbishedBrands.filter((item) => item !== filterId)
                // On supprime toutes les gammes associées à cette marque
                let brand = this.filtersRefurbishedBrand.checkboxes.find(item => item.id === filterId)
                if (brand?.ranges) {
                    let ranges = brand.ranges.map(item => item.id)
                    this.selectedRanges = this.selectedRanges.filter(item => !ranges.includes(item))
                }
            }
            if (filterName === 'segments-filter' || filterName === 'refurbished-segments-filter' || filterName === 'other-segments-filter') this.selectedSegments = this.selectedSegments.filter((item) => item !== filterId)
            if (filterName === 'compatibility-filter') this.selectedCompatibilities = this.selectedCompatibilities.filter((item) => item !== filterId)
            if (filterName === 'price-filter') this.selectedPrices = this.selectedPrices.filter((item) => item !== filterId)
            if (filterName === 'repairability-filter') this.selectedRepairabilities = this.selectedRepairabilities.filter((item) => item !== filterId)
            if (filterName === 'bonus-recovery-filter') {
                this.selectedBonusRecovery = "";
                this.selectedBonusRecoveryRanges = [];
            }

            this.updateUrl()
            this.filterMobiles()
        },
        deleteRangeHandler: function (rangeId, brandId, refurbished) {
            this.selectedRanges = this.selectedRanges.filter((item) => item !== rangeId)
            // si plus aucune gamme pour une marque, on met la marque dans l'url
            if (refurbished) {
                let refurbishedBrand = this.filtersRefurbishedBrand.checkboxes.find(item => item.id === brandId)
                if (refurbishedBrand && refurbishedBrand.ranges.filter(item => item.isChecked).length === 0) {
                    this.selectedRefurbishedBrands.push(brandId)
                }
            } else {
                let brand = this.filtersBrand.checkboxes.find(item => item.id === brandId)
                if (brand && brand.ranges.filter(item => item.isChecked).length === 0) {
                    this.selectedBrands.push(brandId)
                }
            }

            this.updateUrl()
            this.filterMobiles()
        },
        deleteBonusRangeHandler: function (rangeId) {
            this.selectedBonusRecoveryRanges = this.selectedBonusRecoveryRanges.filter((item) => item !== rangeId);

            this.updateUrl();
            this.filterMobiles();
        },
        //Mise à jour des filters si suppression du chips etat
        deleteStatusHandler: function () {
            this.selectedStatus = "";

            this.updateUrl()
            this.filterMobiles()
        },
        filterMobiles: function () {
            this.page = 1
            this.loadMobiles(0, this.page * this.paginationSize)
        },
        onDeleteSelectionClick: function () {
            Tms.link({category: "selecteur_produit", action: "effacer_mes_filtres", label: "effacer_mes_filtres"});

            this.selectedStatus = "";
            this.selectedBonusRecovery = "";
            this.selectedBonusRecoveryRanges = [];
            this.selectedBrands = [];
            this.selectedRefurbishedBrands = [];
            this.selectedRanges = [];
            this.selectedSegments = [];
            this.selectedCompatibilities = [];
            this.selectedPrices = [];
            this.selectedRepairabilities = [];

            this.showSelectorCard = false;
            this.page = 1
            this.updateUrl()
            this.loadMobiles(0, this.getPageNumber() * this.paginationSize);
        },

        updateUrl: function () {
            let url = location.protocol + '//' + location.host + location.pathname
            if (this.disu) {
                url = addParam(url, 'disu=' + this.disu)
            }
            if (this.availableOnline) {
                url = addParam(url, 'availableOnline=' + this.availableOnline)
            }
            if (this.selectedBrands.length > 0) {
                url = addParam(url, 'brand=' + this.selectedBrands.join(','))
            }
            if (this.selectedRanges.length > 0) {
                url = addParam(url, 'range=' + this.selectedRanges.join(','))
            }
            if (this.selectedRefurbishedBrands.length > 0) {
                url = addParam(url, 'refurbished-brand=' + this.selectedRefurbishedBrands.join(','))
            }
            if (this.selectedPrices.length > 0) {
                url = addParam(url, 'price=' + this.selectedPrices.join(','))
            }
            if (this.selectedRepairabilities.length > 0) {
                url = addParam(url, 'repairability=' + this.selectedRepairabilities.join(','))
            }
            if (this.selectedCompatibilities.length > 0) {
                url = addParam(url, 'compatibility=' + this.selectedCompatibilities.map((it) => encodeURIComponent(it)).join(','))
            }
            if (this.selectedSort && this.selectedSort !== "") {
                url = addParam(url, 'sort=' + this.selectedSort)
            }
            if (this.selectedSegments.length > 0) {
                url = addParam(url, 'segment=' + this.selectedSegments.join(','))
            }
            if (this.selectedStatus && this.selectedStatus !== "") {
                url = addParam(url, 'status=' + this.selectedStatus)
            }
            if (this.selectedBonusRecoveryRanges.length > 0) {
                url = addParam(url, 'bonus-ranges=' + this.selectedBonusRecoveryRanges.join(','));
            } else if (this.selectedBonusRecovery && this.selectedBonusRecovery !== "") {
                url = addParam(url, 'bonus=' + this.selectedBonusRecovery);
            }
            if (this.offerSeoId && this.hasOfferFromUrl) {
                url = addParam(url, 'offer=' + this.offerSeoId);
            }
            // intention
            let existingIntentionParam = getUrlParam(window.location.href, 'intention');
            if (existingIntentionParam !== "") {
                url = addParam(url, 'intention=' + existingIntentionParam)
            }
            url = addParam(url, 'page=' + this.page)

            window.history.pushState(null, '', url)
        },
        updatePageUrlWithIntention() {
            if (this.intentionParam === RENOUVELLEMENT_PARAM || this.intentionParam === CHANGER_DE_MOBILE_PARAM){
                return window.history.replaceState({}, null, updateUrlWithParam(window.location.href, "intention", CHANGER_DE_MOBILE_PARAM))
            }
            else return window.history.replaceState({}, null, updateUrlWithParam(window.location.href, "intention", this.intentionParam))
        },
        switchIntention(selectedId) {

            if (this.customerPopin && selectedId === "intention-changer-de-mobile") {
                $('#customer-popin-id').modal('show')
            } else if (this.shop === "ORANGE" && selectedId === "intention-changer-de-mobile") {
                window.location.href = updateUrlWithParam(window.location.href, "intention", CHANGER_DE_MOBILE_PARAM);
            } else {
                if (selectedId === "intention-tseul") {
                    this.fundingDetailsDto = this.selectorDto.fundingDetailsTseulDto
                    this.intentionParam = TSEUL_PARAM;
                } else if (selectedId === "intention-acquisition") {
                    this.fundingDetailsDto = this.selectorDto.fundingDetailsDto
                    this.intentionParam = ACQUISITION_PARAM;
                } else if (selectedId === "intention-changer-de-mobile") {
                    this.fundingDetailsDto = this.selectorDto.fundingDetailsDto
                    // On est sur sosh : on force l'intention renouvellement
                    this.intentionParam = RENOUVELLEMENT_PARAM;
                }
                this.showSelectorCard = false;
                this.selectedOffer = this.selectorDto.selectedOffer?.intention === this.intentionParam ? this.selectorDto.selectedOffer : null;
                this.loadFilters(this.intentionParam).then(
                    filters => {
                        this.filters = filters
                        this.loadMobiles(0, this.getPageNumber() * this.paginationSize);
                    }
                );

                this.updateFinancingPopin();
                this.updatePageUrlWithIntention();
                this.updateTmsData();
            }
        },
        displayAnimation(brandFilters, segments, refurbishedBrandFilters, hasAppleBrandFilteredRanges) {
            return !this.hideAnimation(brandFilters, segments, refurbishedBrandFilters, hasAppleBrandFilteredRanges)
        },
        hideAnimation(brandFilters, segments, refurbishedBrandFilters, hasAppleBrandFilteredRanges) {
            return brandFilters?.includes("apple")
                || hasAppleBrandFilteredRanges
                || this.selectedStatus === "reconditionne"
                || segments?.includes("reconditionnes")
                || segments?.includes("famille15")
                || (refurbishedBrandFilters.length !== 0
                    && brandFilters.length === 0) //filtre un ou plusieurs mobiles reconditionnés sélectionné uniquement
        },
        updateTmsData() {
            if (!window.o_utagview || !tmsData) return;
            if ((this.shop === "SOSH" && this.intentionParam === RENOUVELLEMENT_PARAM) || this.intentionParam === TSEUL_PARAM) {
                tmsData.contexte_produit = "acquisition_terminal_seul"
            } else if (this.intentionParam === ACQUISITION_PARAM) {
                tmsData.contexte_produit = "acquisition_terminal_vers_forfait"
            } else if (this.intentionParam === PCM_PARAM) {
                tmsData.contexte_produit = "changement_pcm"
            } else if (this.intentionParam === RENOUVELLEMENT_PARAM) {
                tmsData.contexte_produit = "changement_renouvellement"
            }
            Tms.view(tmsData)
        },
        updateLayout() {
            //nombre de tuiles par ligne selon le media (mobile, tablette et desktop)
            let nbOfTilesPerRow = 1
            if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.xl + "px)").matches) {
                nbOfTilesPerRow = 3
            } else if (window.matchMedia("(min-width: " + myshop.ob1.breakpoints.md + "px)").matches) {
                nbOfTilesPerRow = 2
            }

            this.alignCardItemsVertically(".selector-card .mobile-infos", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-card .infos-price", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-card .infos-advantage", nbOfTilesPerRow);
            this.alignCardItemsVertically(".selector-card .payment-solutions-details", nbOfTilesPerRow);
            this.alignCardItemsVertically(".cart-item-status-wrapper", nbOfTilesPerRow);

        },
        alignCardItemsVertically(selector, nbOfTilesPerRow) {
            let listElements = document.querySelectorAll(selector);
            if (listElements.length > 0) {
                for (let row = 0; row < listElements.length; row += nbOfTilesPerRow) {
                    let tmp = [];
                    tmp.push(Array.from(listElements).slice(row, row + nbOfTilesPerRow));
                    let elements = tmp.flat()
                    if (elements.length > 0) {
                        this.alignItemsVertically(elements, nbOfTilesPerRow)
                    }
                }
            }
        },
        getMaximumHeight(list) {
            const heights = Array.from(list)
                .filter(elt => !$(elt).is(".navads"))
                .map(elt => $(elt).height());
            return Math.max(...heights);
        },
        alignItemsVertically(list, nbOfTilesPerRow) {
            Array.from(list).forEach(elt => {
                elt.style.removeProperty("height")
            });
            //Pas de mise à jour de hauteur de ligne pour media mobile
            if (nbOfTilesPerRow > 1) {
                const maxHeight = this.getMaximumHeight(list);
                if (maxHeight === 0) {
                    return;
                }
                Array.from(list).forEach(elt => {
                    if (!$(elt).is(".navads")) {
                        $(elt).height(maxHeight)
                    }
                });

            }
        },

        handleFundingDetailsClick(versionSeoId) {
            this.selectedFundingDetailVersionPrice = this.mobiles.find(mobile => mobile.currentVersion.seoId.value === versionSeoId)?.currentVersion?.price?.price ?? undefined;
            // On doit attendre le prochain cycle de rendu sinon l'affichage de la popin se fait trop rapidement
            // et la modification de `selectedFundingDetailVersionPrice` n'a pas eu le temps de se "propager" dans le DOM.
            this.$nextTick(() => {
                this.showFundingPopin();
            });

        },
        handleRecoMobilesFundingDetailsClick(versionSeoId) {
            this.selectedFundingDetailVersionPrice = this.reco.mobiles.find(mobile => mobile.seoId.value === versionSeoId)?.price?.price ?? undefined;
            // On doit attendre le prochain cycle de rendu sinon l'affichage de la popin se fait trop rapidement
            // et la modification de `selectedFundingDetailVersionPrice` n'a pas eu le temps de se "propager" dans le DOM.
            this.$nextTick(() => {
                this.showFundingPopin();
            });
        },
        showFundingPopin() {
            const popin = $("#funding-details-popin");
            if (popin) {
                popin.modal("show");
            }
        },
        updateFinancingPopin() {
            if (this.intentionParam === TSEUL_PARAM){
                this.fundingDetailsDto = this.selectorDto.fundingDetailsTseulDto
            } else {
                this.fundingDetailsDto = this.selectorDto.fundingDetailsDto
            }
        },
        deviceAlreadyInCartLabel(model) {
            return model.hasDeviceInCart ? this.selectorDto.deviceAlreadyInCartLabel : null;
        }

    }
}
</script>
